export default __webpack_public_path__ + "static/media/en.8f8f0119.svg";